export default {
  SET_COURSES_FETCH_STATUS (state, status) {
    state.coursesFetchStatus = status
  },

  SET_COURSES_LATEST (state, courses) {
    state.latestCourses = courses;
  },

  SET_POPULAR_COURSES (state, courses) {
    state.popularCourses = courses;
  },

  SET_LATEST_COURSES_FETCH_STATUS (state, status) {
    state.latestCoursesFetchStatus = status
  },

  SET_POPULAR_COURSES_FETCH_STATUS (state, status) {
    state.popularCoursesFetchStatus = status
  },

  SET_COURSES (state, courses) {
    state.courses = courses
  },

  SET_MEMBER_COURSES (state, courses) {
    state.memberCourses = courses
  },

  SET_RECENT_VIEWED_COURSE (state, course) {
    state.recentCourse = course
  },

  UPDATE_RECENT_VIEWED_COURSE (state, course) {
    state.recentCourse = course
  },

  ADD_MEMBER_LEARNING (state, { course, memberCourse }) {
    const modified = memberCourse.modules.map(module => {
      module.units = _.keyBy(module.units, memberUnit => memberUnit.unit.orderIndex)
      return module
    });

    if (!state.memberLearning[course.slug]) {
      state.memberLearning = {
        ...state.memberLearning,
        [course.slug]: {
          ...memberCourse,
          modules: _.keyBy(modified, memberModule => memberModule.module.orderIndex)
        }
      }
    } else {
      state.memberLearning[course.slug] = {
        ...memberCourse,
        modules: _.keyBy(modified, memberModule => memberModule.module.orderIndex)
      }
    }
  },

  ADD_RESOURCES (state, { slug, resources, key }) {
    if (!state.resources[slug]) {
      state.resources = {
        ...state.resources,
        [slug]: {
          [key]: resources
        }
      }
    } else {
      state.resources[slug][key] = resources
    }
  },

  ADD_ASSESSMENT (state, { slug, assessment, key }) {
    if (!state.assessments[slug]) {
      state.assessments = {
        ...state.assessments,
        [slug]: {
          [key]: assessment
        }
      }
    } else {
      state.assessments[slug][key] = assessment
    }
  },

  UPDATE_MEMBER_UNIT (state, { data, path }) {
    const oldData = _.get(state, path)

    state = _.set(state, path, {...oldData, ...data})
  },

  SET_BADGES (state, data) {
    state.badges = data
  }
}
